import React from 'react';

type Props = {
  orderId: string;
  onBack(): void;
};

export default function NeedOrderUpdatePage(props: Props) {
  return (
    <>
      <header>
        <h4>You’ll need to update the order first</h4>
      </header>
      <main>
        <div className='request-refund-modal__page-content'>
          <p>
            Refunds for order changes are handled during the edit process. Once
            you update the order, you&apos;ll be able to choose an appropriate
            order update options, and if the changes leads to a refund, you can
            submit the refund request afterwards.
          </p>
          <b>Steps</b>
          <ol>
            <li>Open the order for editing.</li>
            <li>Make the necessary changes (date, participants, etc.).</li>
            <li>Review and select order update option.</li>
            <li>
              If the update leads to a refund, you can request it after
              confirming the changes.
            </li>
          </ol>
        </div>
      </main>
      <footer className='modal__footer'>
        <menu className='modal__actions modal__actions--between'>
          <button
            key='back'
            className='btn btn-secondary btn--wide'
            type='button'
            onClick={props.onBack}
          >
            Back
          </button>
          <button
            key='editOrder'
            className='btn btn-primary btn--wide'
            type='button'
            onClick={() => {
              window.location.assign(`/orders/${props.orderId}/edit/`);
            }}
          >
            Edit Order
          </button>
        </menu>
      </footer>
    </>
  );
}
